import styled, { keyframes } from "styled-components";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { DarkGrey, White08 } from "../theme/colors";

// Shimmer animation matching DailyVibeCheckBox
const shimmer = keyframes`
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
`;

// Override swipeable list styles to prevent red line persistence
const SwipeableListOverrides = `
  .swipeable-list-item {
    position: relative;
    overflow: hidden;
  }
  
  .swipeable-list-item .swipeable-list-item__content {
    transition: transform 0.2s ease-out !important;
  }
  
  .swipeable-list-item:not(.swipeable-list-item--swiped) .swipeable-list-item__content {
    transform: translateX(0) !important;
  }
`;

// Inject styles once
if (typeof document !== "undefined") {
  const style = document.createElement("style");
  style.textContent = SwipeableListOverrides;
  document.head.appendChild(style);
}

// Search container that flows with the page
export const SearchContainer = styled.div`
  padding: 10px 20px 0px;
  background: transparent;
  width: 100%;
  box-sizing: border-box;
`;

export const FriendsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const FriendCard = styled.div`
  display: flex;
  align-items: center;
  border-radius: 15px;
  padding: 0px 20px 15px;
`;

export const FriendInfo = styled.div`
  flex: 1;
  margin-left: 15px;
  display: flex;
  flex-direction: column;
`;

export const SearchResultCard = styled(FriendCard)`
  justify-content: space-between;
`;

export const InfoBox = styled.div`
  border-radius: 10px;
  padding: 40px 30px 60px;
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
`;

export const QuickAddContainer = styled.div`
  margin-bottom: 20px;
`;

export const QuickAddScroll = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  overflow-y: visible;
  gap: 8px;
  padding: 0px 20px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;

export const QuickAddCard = styled.div`
  background: ${DarkGrey};
  min-width: 120px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 10px;
  height: 175px;
  position: relative;

  /* Shimmer overlay matching DailyVibeCheckBox */
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.03) 50%,
      transparent 100%
    );
    background-size: 200% 100%;
    animation: ${shimmer} 8s ease-in-out infinite;
    pointer-events: none;
  }
`;

export const FriendArrow = styled(ArrowForwardIosIcon)`
  color: ${White08};
  font-size: 18px !important;
`;

export const RemoveSwipeButton = styled.button`
  background: #ff4444;
  color: #fff;
  border: none;
  border-radius: 8px 0 0 8px;
  font-size: 16px;
  font-weight: 700;
  padding: 0 24px;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  transition: none;
  position: relative;
  z-index: 1;
`;

export const TraitsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 5px;
`;

export const TraitItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

// New styled components for friend list items
export const FriendListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  width: 100%;
`;

export const FriendListInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const FriendDetailsColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FriendNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
